
export const storeListSelectorSaga = (state) => (state.storePageReducer?.storeDetailsRows && state.storePageReducer?.storeDetailsRows.constructor === Array) ? [...state.storePageReducer?.storeDetailsRows].sort((a,b) => a.sourceId - b.sourceId) : state.storePageReducer?.storeDetailsRows;

export const selectedStoreSelectorSaga = (state) => state.storePageReducer.selectedStore;

export const singleStoreDetailsSaga = (state) => state.storePageReducer.singleStoreDetailsRows;

export const singleStoreDetailsErrorSaga = (state) => state.storePageReducer.singleStoreDetailsRowsError;
